/**
 *
 * FreshPets Font Sizes
 *
 */
const fontSizes = [ 12, 14, 16, 20, 24, 32, 48, 64, 96 ]

export default fontSizes